<!--
  ~ Copyright (c) GM Global Technology Operations LLC. All rights reserved.
  ~ This information is confidential and proprietary to GM Global Technology
  ~ Operations LLC and may not be used, modified, copied or distributed.
  -->
<h1 mat-dialog-title>Edit User</h1>
<div id="actions-container">
  <button mat-stroked-button class="action-button" id="cancel-button" (click)="onCancel()">Cancel</button>
  <button mat-raised-button class="action-button" color="primary" id="submit-button" (click)="onSubmit()">
    Submit
  </button>
</div>
<div mat-dialog-content>
  <fab-loading-spinner color="primary" *ngIf="showSpinner"></fab-loading-spinner>
  <form *ngIf="userForm" [formGroup]="userForm">

    <mat-form-field appearance="fill">
      <mat-label>User ID</mat-label>
      <input matInput maxlength="6" id="userID-input" formControlName="id"/>
    </mat-form-field>
    <mat-form-field appearance="fill">
      <mat-label>First Name</mat-label>
      <mat-hint>Required</mat-hint>
      <input matInput maxlength="25" id="firstName-input" formControlName="firstName"/>
    </mat-form-field>
    <mat-form-field appearance="fill">
      <mat-label>Last Name</mat-label>
      <mat-hint>Required</mat-hint>
      <input matInput maxlength="25" id="lastName-input" formControlName="lastName"/>
    </mat-form-field>
    <br/>

    <mat-form-field appearance="fill">
      <mat-label>Security Level</mat-label>
      <mat-select id="secLevel-option" formControlName="role">
        <mat-option *ngFor="let list of secList" [value]="list.value">
          {{list.viewValue}}
        </mat-option>
      </mat-select>
    </mat-form-field>
    <mat-form-field appearance="fill">
      <mat-label>Global FCORG</mat-label>
      <mat-select id="fcorg-option" [(ngModel)]="selectedFcorgs" multiple formControlName="fcorgs">
        <mat-option *ngFor="let group of fcorgList" [value]="group.fcorg" (onSelectionChange)="fcorgChange($event)">
          {{group.fcorg}}
        </mat-option>
      </mat-select>
    </mat-form-field>
    <mat-form-field appearance="fill">
      <mat-label>Regions</mat-label>
      <mat-select id="region-option" formControlName="regions" [disabled]="!selectedFcorgs" [compareWith]="compareObjects" [(ngModel)]="regionMap" multiple>
        <mat-optgroup *ngFor="let group of selectedFcorgs" [label]="group">
          <mat-option *ngFor="let region of regionList" [value]="getRegionMapValue(region.region, group)">
            {{region.region}}
          </mat-option>
        </mat-optgroup>
      </mat-select>
    </mat-form-field>
    <br/>

    <div class="users-div">
      <mat-card appearance="outlined" class="mat-card-container default-padding">
        <mat-card-title>Global FCORG-Region</mat-card-title>
        <div class="gfs-table">

          <ag-grid-angular
            style="height: 100%; width:100%;"
            class="ag-theme-quartz"
            [rowData]="regionMap"
            [columnDefs]="fcorgRegionMapColumns"
            [autoSizeStrategy]="autoSizeStrategy"
          />
        </div>
      </mat-card>
    </div>

  </form>

</div>
